import { Module } from 'vuex'
import { State } from '@plugin/store'

import { storage } from '@utils/index'

import { signIn, signOut, getCurrentUser, getMainPage } from '@/api/common/index'

import { getLanguage } from '@/plugin/i18n/index'

const token = storage.get('token') as string

const dbName = storage.get('dbName') as string

const supDistinguish = storage.get('supDistinguish') as string

const fixedMenu = storage.get('fixedMenu')

const remoteBarcode = storage.get('remoteBarcode') as string

export interface App {
  token: string; // token
  supDistinguish: string; // 供应商还是采购商
  userInfo: object; // 登录信息
  loadingList: string[]; // 加载请求的列表
  documentWidth: number; // html宽度
  documentHeight: number; // html高度
  appWidth: number; // app区域的宽度
  appHeight: number; // app区域的高度
  fixedMenu: boolean; // 固定菜单栏
  scrollTop: number; // 滚动位置
  atBottom: boolean; // 是否滚动到页面底部
  scrollBottom: number; // 滚动距离底部距离
  language: string; // 国际化语言类别
  dbName: string; // 登录时的采购域
  guideInfo: object; // 安装配置信息
  remoteBarcode: string;
}

const store: Module<App, State> = {
  namespaced: true,
  state: {
    token,
    supDistinguish,
    userInfo: {},
    loadingList: [],
    documentWidth: document.documentElement.clientWidth,
    documentHeight: document.documentElement.clientHeight,
    appWidth: 0,
    appHeight: 0,
    fixedMenu: !!fixedMenu,
    scrollTop: 0,
    atBottom: false,
    scrollBottom: 0,
    language: getLanguage(),
    dbName,
    guideInfo: {},
    remoteBarcode
  },
  mutations: {
    // 设置登陆信息
    SET_LOGIN_INFO(state, info = {}) {
      const token = info.token || ''
      storage.set('token', token)
      state.token = token
      storage.set('supDistinguish', info.officeType)
      state.supDistinguish = info.officeType
      storage.set('remoteBarcode', info.remoteBarcode)
      state.remoteBarcode = info.remoteBarcode
    },
    // 设置dbName
    SET_DBNAME(state, dbName) {
      storage.set('dbName', dbName)
      state.dbName = dbName
    },
    SET_USERINFO(state, info = {}) {
      state.userInfo = info
    },
    // 添加loading
    ADD_LOADING(state, url) {
      state.loadingList.push(url)
    },
    // 去除loading
    REMOVE_LOADING(state, url) {
      state.loadingList.splice(state.loadingList.indexOf(url), 1)
    },
    // 设置页面尺寸
    SET_APPSIZE(state, size) {
      state.documentWidth = size.documentWidth
      state.documentHeight = size.documentHeight
      state.appWidth = size.appWidth
      state.appHeight = size.appHeight
    },
    // 设置页面滚动位置
    SET_POSITION(state, position) {
      const { scrollTop = state.scrollTop, atBottom = state.atBottom, scrollBottom = state.scrollBottom } = position
      state.scrollTop = scrollTop
      state.atBottom = atBottom
      state.scrollBottom = scrollBottom
    },
    // 设置固定菜单
    SET_FIXED_MENU(state, flag) {
      const fixed = flag || ''
      storage.set('fixedMenu', fixed)
      state.fixedMenu = !!fixed
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      storage.set('language', language)
    },
    SET_GUIDEINFO(state, info = {}) {
      state.guideInfo = info
    }
  },
  actions: {
    async login({ commit }, data) {
      const info: any = await signIn(data) || {}
      commit('SET_LOGIN_INFO', info)
      commit('SET_DBNAME', info.dbName)
      return info
    },
    async exit({ commit }) {
      await signOut()
      commit('SET_LOGIN_INFO')
    },
    async getUserInfo({ commit }) {
      const info = await getCurrentUser()
      commit('SET_USERINFO', Object.freeze(info || {}))
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    async getGuideInfo({ commit }) {
      const info = await getMainPage()
      commit('SET_GUIDEINFO', Object.freeze(info || {}))
    }
  }
}
export default store
